/** ODP v2 typography tokens */

export const fontFamilyCorpoATextCondensed =
  "'MB Corpo A Text Condensed', 'MB Corpo S Text Condensed', 'Helvetica Neue', Arial, sans-serif";

export const fontFamilyCorpoATitle =
  "'MB Corpo A Title', 'MB Corpo S Title', 'Helvetica Neue', Arial, sans-serif";

export const fontFamilyCorpoSText =
  "'MB Corpo S Text', 'Helvetica Neue', Arial, sans-serif";

export const typography = {
  fontFamily: fontFamilyCorpoSText,
  fontFamilyCorpoSText,
  fontFamilyCorpoATextCondensed,
  fontFamilyCorpoATitle,
  heroTitle: {
    fontFamily: fontFamilyCorpoATitle,
    fontSize: '56px',
    fontWeight: 400,
  },
  cardHeader: {
    fontFamily: fontFamilyCorpoATextCondensed,
    fontSize: '40px',
    fontWeight: 400,
  },
  pageTitle: {
    fontFamily: fontFamilyCorpoATitle,
    fontSize: '2.5rem',
    fontWeight: 400,
  },
  sectionTitle: {
    fontFamily: fontFamilyCorpoATextCondensed,
    fontSize: '1.5rem',
    fontWeight: 400,
  },
  body: {
    fontFamily: fontFamilyCorpoSText,
    fontSize: '0.875rem',
    fontWeight: 400,
  },
} as const;
